import { Modal, Text, Button, Stack, ThemeIcon } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface SessionExpiredModalProps {
  opened: boolean;
  onGoToLogin: () => void;
}

function SessionExpiredModal({ opened, onGoToLogin }: SessionExpiredModalProps) {
  const { t } = useTranslation('common');

  return (
    <Modal
      opened={opened}
      onClose={() => {}}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      overlayProps={{ backgroundOpacity: 0.6, blur: 4 }}
      styles={{
        content: {
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
        },
        body: {
          padding: '32px',
        },
      }}
    >
      <Stack align="center" gap="md">
        <ThemeIcon
          size={64}
          radius="xl"
          variant="gradient"
          gradient={{ from: '#2F3289', to: '#40266A', deg: 45 }}
        >
          <IconLock size={32} />
        </ThemeIcon>

        <Text
          fw={700}
          size="xl"
          ta="center"
          style={{ color: '#2F3289' }}
        >
          {t('sessionExpired.title')}
        </Text>

        <Text
          size="sm"
          c="dimmed"
          ta="center"
          maw={320}
        >
          {t('sessionExpired.description')}
        </Text>

        <Button
          fullWidth
          size="md"
          mt="sm"
          variant="gradient"
          gradient={{ from: '#2F3289', to: '#40266A', deg: 45 }}
          radius="md"
          onClick={onGoToLogin}
        >
          {t('sessionExpired.button')}
        </Button>
      </Stack>
    </Modal>
  );
}

export default SessionExpiredModal;
